import Flickity from 'flickity';
require('flickity-sync');
require('flickity-fade');

const $propertyGalleryToggle = document.querySelectorAll('.js-toggle-property-gallery');
const $propertyGallery = document.querySelector('.property-gallery');
const gallery = document.querySelector('#property-gallery-slider');
const captions = document.querySelector('#property-gallery-slider__captions');

if (gallery && captions) {
	const flkty = new Flickity(gallery, {
		pageDots: false,
		percentPosition: false,
		wrapAround: true,
		sync: captions,
	});

	const flktyCaptions = new Flickity(captions, {
		pageDots: false,
		percentPosition: false,
		wrapAround: true,
		fade: true,
		prevNextButtons: false,
		sync: gallery,
	});

	function toggleGallery() {
		$propertyGallery.classList.toggle('toggle');
		flkty;
		flktyCaptions;
	}

	flkty.on('change', () => {
		updateCounter();
	});

	function updateCounter() {
		document.querySelector('#property-gallery-cur-number').innerHTML = (flkty.selectedIndex + 1);
	}

	$propertyGalleryToggle.forEach(function(btn) {
		btn.addEventListener('click', function() {
			toggleGallery();
		});
	});
}
